module.exports = __webpack_public_path__ + "img/08.aea4ab08.png";